export default __webpack_public_path__ + "media/zurb/img/lab/playground/motion-ui/yeti-7392ae8f759a2565381552fb9673261b.svg";